var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooth25(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.81 189.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.92,132.67s0,39.84-4.69,51.56c-4.69,11.72-11.72-4.69-11.72-4.69l-2.34-37.5L6.14,62.36C3.8,57.67,2.7,20.28,1.46,13.15.22,6.02,3.12,1.43,8.49,1.43h23.43s11.72-2.34,11.72,7.03c0,0,0,42.18-4.69,53.9-4.69,11.72-7.03,70.3-7.03,70.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m13.17,57.67s11.72,4.69,18.75,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooth25);
export default __webpack_public_path__ + "static/media/tooth-25.088d9001a3bb6a43dc118b63e27a868f.svg";
export { ForwardRef as ReactComponent };